import { jsx } from "react/jsx-runtime";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { validateTidalLicense } from "../../base/index.js";
function ArrowForward(props) {
  return /* @__PURE__ */ jsx(
    ArrowForwardIcon,
    {
      "data-testid": "ArrowForward",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "ArrowForward",
      "data-tidal-icon-meta": "arrows"
    }
  );
}
ArrowForward.tidalIconMeta = {
  categories: "arrows",
  name: "ArrowForward"
};
validateTidalLicense();
export {
  ArrowForward
};
//# sourceMappingURL=ArrowForward.js.map
